import React, { useContext, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import config from '../../config';
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";
import { useParams } from 'react-router-dom';
import { GlobalContext } from '../../GlobalProvider';
import Container from '../../components/common/Container';
import useSocket from '../../Websoket.js';
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import ExchanngeinfoPopup from '../../components/matchData/ExchanngeinfoPopup';
import Popup from '../../components/common/popup/Popup';
import MatchNotFound from '../../components/matchData/MatchNotFound';
import BackPricesBox from '../../components/box/BackPricesBox';
import LayPricesBox from '../../components/box/LayPricesBox';
import BMLayPriesBox from '../../components/box/BMLayPriesBox.jsx';
import BMBackPriceBox from '../../components/box/BMBackPriceBox.jsx';
import FancyNoValueBox from '../../components/box/FancyNoValueBox.jsx';
import FancyYesValueBox from '../../components/box/FancyYesValueBox.jsx';
import { PopupContext } from '../../components/LoginPopup/LoginPopupContext.js';
import betslipclosearrow from '../../assets/images/betslip-close-arrow.png'
import Scoreboard from '../../components/Scoreboard/Scoreboard.js';
import StringToHtml from '../../StringToHtml.jsx';
import FancyBookPopup from '../../components/matchData/Fancy/FancyBookPopup.js';

export default function NewExchInner() {
    const { eventId } = useParams();
    const [apiResponse, setApiResponse] = useState();
    const [isStreamOpen, setStreamOpen] = useState(false);
    const [scoreOrTvLive, setScoreOrTvLive] = useState('Score');
    const [isOpen, setIsOpen] = useState(null);
    const [isMobileBetsOpen, setIsMobileBetsOpen] = useState(null);
    const [matchStatuss, setMatchStatus] = useState(0);
    const [fancyBookPopup, setFancyBookPopup] = useState()
    const [betPopup, setBetPopup] = useState(false);
     const [betresultMsg, setBetresultMsg] = useState();
    const initialized = useRef(false);
    const [matchCheck, setMatchCheck] = useState('');
    const [liveStreamSlide, setLiveStreamSlide] = useState('open');
    const [scoreAPICall, setScoreAPICall] = useState(false);
    const [multimarketArray, setMultimarketArray] = useState([])
        const [grulesPopup, setGrulesPopup] = useState();
    
    const [key, setKey] = useState(0);
    const handleClick = (section) => {
      if (isOpen === section) {
       setIsOpen('');
      } else {
       setIsOpen(section);
      }
    };

    useEffect(() => {
        const idleCallback = () => {
          console.log('Main thread is idle, perform background tasks');
          // You can perform lightweight tasks here without blocking UI
        };
    
        if ('requestIdleCallback' in window) {
          requestIdleCallback(idleCallback); // Schedule to run when the thread is idle
        } else {
          // Fallback for browsers that don't support requestIdleCallback
          setTimeout(idleCallback, 1);
        }
    
        return () => {
          // Cleanup if needed
        };
      }, []);
 
    const [marketID, setsetMakerID] = useState([]);
    const [matchOdd, setMatchOdd] = useState();
    const [underOver, setUnderOver] = useState();
    const [tideMatch, setTideMatch] = useState();
    const [bookmakerMarket, setBookmakerMarket] = useState();
    const [fancyData, setFancyData] = useState([]);
    const [allMinMax, setAllMinMax] = useState([]);
    const [tab, setTab] = useState('all');
    const [usersideBook, setUserSideBook] = useState([]);
    const [stack, setStack] = useState([]);
    const [myNotification, setMyNotification] = useState();
    const {setGameRule, openPopup , loggedIn, isLoggedOut,direactsecId, setSecIds,isBetUpdate,betNotUpdated,clearSecId,unsetBetLoader,loaderCounting,isBetLoader, loaderCounter,stackArray,setBetLoder } = useContext(PopupContext);
    const {openSuccessPopup, openErrorPopup, setAlertMsg } = useContext(GlobalContext);
    const { isConnected, receivedBetlistData, receivedToken, sendMessage, receivedMinMax, receivedAllBookData, receivedcashoutMO, receivedcashoutBm, receivedBookFancy } = useSocket();
    let userInfo = sessionStorage.getItem('userinfo');
    let fancyType = ["OVERS", "BATSMAN","SINGLE_OVER", "ODD_EVEN", "WINNING_SEATS", "BALL_BY_BALL"]
    let fancyNormalType = []
    const [isCashOut, setCashOut] = useState(false);
 
    const hasAnyFancyType = fancyNormalType.some((type) =>
       fancyData?.some((item) => item.category === type)
     );
 
    let matchDataAccess = {
       "eventId": eventId,
       "userId": process.env.REACT_APP_ENV === 'development' ? '64db25fa1617ac95db367a0d' : '65fc48e7eab864a79776c01c'
   };
   if (userInfo) {
       userInfo = JSON.parse(userInfo);
       matchDataAccess = {
           "eventId": eventId,
           "userId": userInfo._id
       };
 
   }
   const [scoresUrl, setScoreUrl] = useState("");
   const [tvUrl, setTvUrl] = useState("");
   const [tvUrlFalg, setTvUrlFlag] = useState(true);
   const [profitLossData, setProfitLossData] = useState({}); // Store dynamic data
   const [betlistData, setBetlistData] = useState(matchDataAccess);
   const iframeUrlRef = useRef("");
 
   useEffect(()=>{
        console.log("betlistData",receivedBetlistData);
        
   },[receivedBetlistData,loaderCounter])

   const gameCheckInterval = useRef(null);

    useEffect(() => {
        checkGameStart(); // Initial call

        if (!gameCheckInterval.current) {
            gameCheckInterval.current = setInterval(() => {
                checkGameStart();
            }, 30000);
        }

        return () => {
            if (gameCheckInterval.current) {
                clearInterval(gameCheckInterval.current);
                gameCheckInterval.current = null;
            }
        };
    }, []);

    const checkGameStart = async () => {
        setTimeout(async () => {
            try {
                const myHeaders = new Headers({ "Content-Type": "application/json" });

                if (sessionStorage.getItem("token") || loggedIn) {
                    myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
                }

                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/matchStatus?eventId=${eventId}`,
                    {
                        method: "GET",
                        headers: myHeaders,
                        redirect: "follow"
                    }
                );

                const paresData = await response.json();

                if (response.ok) {
                    setMatchStatus(
                        paresData?.matchStatus === "IN_PLAY" || paresData?.matchStatus === "UPCOMING" ? 1 : 2
                    );
                } else {
                    setMatchStatus(2);
                }

                setMatchCheck(paresData?.matchStatus);
            } catch (error) {
                console.error("Fetch Error:", error);
            }
        }, 0); // Offload work
    };

   
    //    useEffect(() => {
    //        let gameCheckInterval;
    //            // Initial call
    //            checkGameStart();
       
    //            // Repeat every 30 seconds
    //            gameCheckInterval = setInterval(() => {
    //                checkGameStart();
    //            }, 30000);
       
    //        return () => {
    //            if (gameCheckInterval) clearInterval(gameCheckInterval);
    //        };
    //    }, []);


   const callScoreAPI = async (data)=>{
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
 
        const raw = JSON.stringify({
          "whiteLabelName": config.WhiteLable,
          "eventId":data?.matchData?.eventId,
          "sportId":data?.matchData?.sportId
        });
 
        const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
        };
 
    fetch(`${process.env.REACT_APP_BASE_URL}/getScoreCard`, requestOptions)
    .then(async (response) => {
      let paresData = await response.json();
      initialized.current = true;
       setScoreUrl(paresData.scorecard);
       setTvUrl(paresData.livestreme);
       setTvUrlFlag(false);
       setScoreAPICall(true);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  const liveStreamHandle = () => {
    setLiveStreamSlide(!liveStreamSlide)
}

   const useWindowWidth = () => {
            const [width, setWidth] = useState(window.innerWidth);
          
            useLayoutEffect(() => {
              const updateWidth = () => setWidth(window.innerWidth);
              window.addEventListener("resize", updateWidth);
              return () => window.removeEventListener("resize", updateWidth);
            }, []);
          
            return width;
          };

          const liveStreamfunction = (width,tvUrl,evId,scoreAPICall) => {
            let user = sessionStorage.getItem('userId');
            if (user == null) {
                return false;
            }else{
                if (user !== (process.env.REACT_APP_ENV === 'development' ? '64db25fa1617ac95db367a0d' : '65fc48e7eab864a79776c01c')){
                    if(width > 767 && scoreAPICall){
                        return true;
                    }else{
                        return false;
                    }
                }else{
                    return false;
                }
            }
        }

        const width = useWindowWidth();

  const formatNumberrr = (num) => {
    const str = num.toString();
    const dotIndex = str.indexOf(".");
 
    // If there is no decimal point, return as is
    if (dotIndex === -1) return num;
 
    // Extract up to two decimal places without rounding
    return str.substring(0, dotIndex + 3);
 };
 
  const initialProfitLossData = useMemo(() => {
    if (!receivedAllBookData || !Array.isArray(receivedAllBookData.showData)) return {};

    return receivedAllBookData.showData.reduce((acc, marketData) => {
        Object.entries(marketData).forEach(([marketId, runners]) => {
            runners.forEach(({ runnerId, amount }) => {
                const key = `${marketId}_${runnerId}`;
                const existingValue = acc[key] ? parseFloat(acc[key]) : 0;
                acc[key] = formatNumberrr(existingValue + amount);
            });
        });
        return acc;
    }, {});
}, [receivedAllBookData]);

useEffect(() => {
    setProfitLossData(initialProfitLossData);
}, [initialProfitLossData]);
 
 useEffect(() => {
    sendMessage('getbetlistdata2', betlistData);
    const intervalId = setInterval(() => {
        sendMessage('getbetlistdata2', betlistData);
    }, 5000);
    return () => {clearInterval(intervalId);}
 }, [apiResponse,isConnected]);
 
 useEffect(() => {
    if (Object.keys(receivedcashoutMO).length > 0 && receivedcashoutMO.secId) {
        setCashOut(true);
        config.DATA = {
            eventId: receivedcashoutMO.eventId,
            marketId: receivedcashoutMO.marketId,
            stake: receivedcashoutMO.stake,
            betType: receivedcashoutMO.betType,
            selectionName: receivedcashoutMO.runnerName,
            odds: receivedcashoutMO.odds,
            marketData:receivedcashoutMO,
            marketType: receivedcashoutMO.marketType,
            secId: `${receivedcashoutMO.secId}`,
            isFancy:config.isNotfancy
        }
        setBetsData({
            eventId: receivedcashoutMO.eventId,
            marketId: receivedcashoutMO.marketId,
            stake: receivedcashoutMO.stake,
            betType: receivedcashoutMO.betType,
            selectionName: receivedcashoutMO.runnerName,
            odds: receivedcashoutMO.odds,
            marketData:receivedcashoutMO,
            marketType: receivedcashoutMO.marketType,
            secId: `${receivedcashoutMO.secId}`,
            isFancy:config.isNotfancy
        });
        setIsBetSlipOpen(true);
        setCurrentBetSlip(`${receivedcashoutMO.marketId}_${receivedcashoutMO.secId}`);
    }
 }, [receivedcashoutMO]);
 
 useEffect(() => {
    if (Object.keys(receivedcashoutBm).length > 0 && receivedcashoutBm.secId) {
        setCashOut(true);
        config.DATA = {
            eventId: receivedcashoutBm.eventId,
            marketId: receivedcashoutBm.marketId,
            stake: receivedcashoutBm.stake,
            betType: receivedcashoutBm.betType,
            selectionName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).runners.find(item => item.runnerId == receivedcashoutBm.secId).runnerName,
            odds: receivedcashoutBm.odds,
            marketType: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketType,
            marketData:apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId),
            secId: `${receivedcashoutBm.secId}`,
            marketName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketName,
            isFancy:config.isNotfancy
        }
        setBetsData({
            eventId: receivedcashoutBm.eventId,
            marketId: receivedcashoutBm.marketId,
            stake: receivedcashoutBm.stake,
            betType: receivedcashoutBm.betType,
            selectionName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).runners.find(item => item.runnerId == receivedcashoutBm.secId).runnerName,
            odds: receivedcashoutBm.odds,
            marketData:apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId),
            marketType: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketType,
            secId: `${receivedcashoutBm.secId}`,
            marketName: apiResponse.matchData.markets.bookmakers.find(item => item.marketId == receivedcashoutBm.marketId).marketName,
            isFancy:config.isNotfancy
        });
        setIsBetSlipOpen(true);
        setCurrentBetSlip(`${receivedcashoutBm.marketId}_${receivedcashoutBm.secId}`);
    }
 }, [receivedcashoutBm]);
 
 const updateBook = (oldStack, newStack) => {
    if (betsData.marketData && Object.keys(betsData.marketData).length > 0 ) {
        let newvalue = newStack;
        let oldvalue = oldStack;
 
        let oddsValue = betsData.odds;
        let currentRunnerID = betsData.secId;
        let currentMakertID = betsData.marketId;
        let currentRunnerPL = profitLossData[`${currentMakertID}_${currentRunnerID}`]
        let otehrRunnerID = betsData.marketData?.runners?.filter(item => item.runnerId != betsData.secId) || [];
        let addValueCurrentRunn = 0
        let addvalueOther = 0
        let diff = 0
        let marketType = betsData?.marketData?.marketType
        console.log(oldStack, newStack, betsData.betType,betsData?.marketData?.marketType);
 
        if(betsData.betType === config.back){
            if(newStack > oldStack){
                console.log('gfgfgf');
                diff = Math.abs(newStack - oldStack)
                if(marketType == 'BOOKMAKER'){
                    addValueCurrentRunn = (diff * oddsValue) / 100
                    addvalueOther = - diff
                }else{
                    addValueCurrentRunn = (diff * oddsValue) - diff
                    addvalueOther = - diff
                }
            }else if(newStack < oldStack){
                diff = Math.abs(oldStack-newStack)
                if(marketType == 'BOOKMAKER'){
                    addValueCurrentRunn = - Math.abs((diff * oddsValue) / 100)
                    addvalueOther =  diff
                }else{
                    addValueCurrentRunn = - Math.abs((diff * oddsValue) - diff)
                    addvalueOther = diff
                }
 
            }
 
        }else{
            if(newStack > oldStack){
                diff = Math.abs(newStack - oldStack)
                if(marketType == 'BOOKMAKER'){
                    addValueCurrentRunn =  - ((diff * oddsValue) / 100)
                    addvalueOther = diff
                }else{
                    addValueCurrentRunn =  - ((diff * oddsValue) - diff)
                    addvalueOther = diff
                }
            }else if(newStack < oldStack){
                diff = Math.abs(oldStack-newStack)
                if(marketType == 'BOOKMAKER'){
                    addValueCurrentRunn =   Math.abs((diff * oddsValue) / 100)
                    addvalueOther =  - diff
                }else{
                    addValueCurrentRunn =  Math.abs((diff * oddsValue) - diff)
                    addvalueOther = - diff
                }
 
            }
        }
        updateProfit(betsData.marketId,currentRunnerID,addValueCurrentRunn)
        for (let i = 0; i < otehrRunnerID.length; i++) {
            const element = otehrRunnerID[i].runnerId;
            updateProfit(betsData.marketId,element,addvalueOther)
        }
    }
 }
 
 const updateProfitLoss = (marketId, runnerId, value) => {
    setProfitLossData(prev => ({
        ...prev,
        [`${marketId}_${runnerId}`]: formatNumberrr(value) // Store data for each marketId & runnerId
    }));
 };

 const updateProfit = (marketId, runnerId, value) => {
    setProfitLossData(prev => {
        const key = `${marketId}_${runnerId}`;
        const existingValue = prev[key] ? parseFloat(prev[key]) : 0; // Get existing value or default to 0
        return {
            ...prev,
            [key]: formatNumberrr(existingValue + value) // Add to existing value
        };
    });
 };
 
    let subscribeChannels = useRef([]);
    const wsRef = useRef(null);
    let heartbeatInterval;
 
    let isOneClicked = sessionStorage.getItem('isOneClicked')
    let oneClickValue
    if(isOneClicked == 'true'){
        oneClickValue = sessionStorage.getItem('oneClickAmount')
    }
 
    const [count, setCount] = useState(0);
    const [betOnProcess, setBetOnProcess] = useState(false);
    const [isBetSlipOpen, setIsBetSlipOpen] = useState(false);
    const [currentBetSlip, setCurrentBetSlip] = useState('');
    const [isMobileBets, setIsMobileBets] = useState(false);
     let countIntervalId = null;
 
    const [betsData,setBetsData] = useState({
       eventId: '',
       marketId: '',
       stake: '',
       betType: '',
       selectionName: '',
       marketName: '',
       odds: '',
       rate: '',
       marketData:{},
       isFancy:''
   });
  
  // Memoize receivedMinMax.minmaxdata
  const memoizedMinMax = useMemo(() => {
    return receivedMinMax?.minmaxdata || [];
  }, [receivedMinMax]);
  
  
  useEffect(() => {
    setAllMinMax(memoizedMinMax);
  }, [memoizedMinMax]);
 
    const publicKeyPEM = `-----BEGIN PUBLIC KEY-----
    MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKik5c/NUnfRBlOR6fgoSwG5YMEgclwe
    BBcPrHR452svxh9lPPNUr8stKqglGU40+ilIzXlsKlZ1sMKh4w6+O6MCAwEAAQ==
    -----END PUBLIC KEY-----`;
 
    // Generate AES key
    const generateAESKey = () => {
        return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex); // 16-byte key
    };
 
    // Encrypt with AES
    const encryptWithAES = (text, key) => {
        return CryptoJS.AES.encrypt(text, key).toString();
    };
 
    // Encrypt AES Key with RSA
    const encryptAESKeyWithRSA = (aesKey) => {
        return new Promise((resolve, reject) => {
            const encryptor = new JSEncrypt();
            encryptor.setPublicKey(publicKeyPEM);
            const encryptedKey = encryptor.encrypt(aesKey);
 
            if (encryptedKey) {
                resolve(encryptedKey);
            } else {
                reject("RSA Encryption failed!");
            }
        });
    };
 
    // Main function
    const encryptLargeMessage = async (message) => {
        try {
            const aesKey = generateAESKey(); // Step 1: Generate AES Key
            const encryptedMessage = encryptWithAES(message, aesKey); // Step 2: Encrypt Message
 
            // Step 3: Encrypt AES Key with RSA (using await)
            const encryptedAESKey = await encryptAESKeyWithRSA(aesKey);
 
            return {
                encryptedMessage,
                encryptedAESKey
            };
        } catch (error) {
            console.error("Encryption failed:", error);
        }
    };
 
    const SendBookDetails_MB = () => {
       let userinfo = sessionStorage.getItem('userinfo');
       if (userinfo && eventId) {
           userinfo = JSON.parse(userinfo);
           sendMessage('marketIdbookDetailsByEventId', { eventId, user: userinfo });
       } else if(!userinfo){
           sendMessage('marketIdbookDetailsByEventId', { eventId });
       }else{
           console.error('Missing eventId or marketId');
       }
   };
 
    const sendBetList = () =>{
        sendMessage('getbetlistdata2', betlistData);
    }
 
    useEffect(() => {
        const encryptData = async () => {
            let final = {};
            if (receivedToken.token) {
                console.log(receivedToken.token, "receivedTokenreceivedTokenreceivedToken");
                let user = JSON.parse(sessionStorage.getItem('userinfo'));
                let string = `${user._id}_${receivedToken.token}_${user.userName}`;
                // Encrypt data
                const enc = await encryptLargeMessage(string);
                let msg = `${enc.encryptedAESKey}_token_${enc.encryptedMessage}`
                let aaa = isOneClicked === "true" ? config.DATA : betsData
                if (!isCashOut) {
                    if (isOneClicked === "true") {
                        aaa.stake = oneClickValue
                    }
 
                    final = {
                        ...aaa,    // If there's any existing data, retain it
                        msg: msg , // Add the new token
                    };
                }else{
                    let asd = config.DATA
                    final = {
                        ...asd,    // If there's any existing data, retain it
                        msg: msg , // Add the new token
                    };
                }
 
                try {
                    // Replace 'your-token' with your actual token
                    const myHeaders = new Headers();
                    myHeaders.append("Content-Type", "application/json");
                    myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);
                    console.log("request :::::: ", final)
                    const requestOptions = {
                        method: "POST",
                        headers: myHeaders,
                        redirect: "follow",
                        body: JSON.stringify(final)
                      };
 
                      fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/bets/placeBet`, requestOptions)
                      .then(async (response) => {
                        if (response.ok) {
                            let result = await response.json();
                            sendBetList();
                            openSuccessPopup();
                            setBetOnProcess(false);
                            clearInterval(countIntervalId);
                            setAlertMsg(result.msg);
                            handleResetBtn();
                            config.DATA = {}
                            SendBookDetails_MB();
                            setCashOut(false);
                            handleClear();
                            setCurrentBetSlip('');
                            setBetresultMsg(result);
                            setBetPopup(true);
                            unsetBetLoader();
                            const betResultpopupTimeer = setTimeout(() => {
                                clearSecId();
                                setBetPopup(false);
                            }, 1500);
                            return () => {
                                clearSecId();
                                clearTimeout(betResultpopupTimeer);
                            }
                        } else{
                            let errorResult = await response.json(); // Parse the JSON error response
                            sendBetList();
                            openErrorPopup();
                            setAlertMsg(errorResult);
                            setBetOnProcess(false);
                            clearInterval(countIntervalId);
                            config.DATA = {};
                            handleResetBtn();
                            setCashOut(false);
                            SendBookDetails_MB();
                            handleClear();
                            unsetBetLoader();
                            setCurrentBetSlip('');
                            setBetresultMsg(errorResult);
                            setBetPopup(true);
                            unsetBetLoader();
                            const betResultpopupTimeer = setTimeout(() => {
                                clearSecId();
                                setBetPopup(false);
                            }, 1500);
                            return () => {
                                clearSecId();
                                clearTimeout(betResultpopupTimeer);
                            }
                        }
 
                      })
                      .catch(async (error) => {
                        sendBetList();
                        SendBookDetails_MB();
                        setCashOut(false);
                        setBetOnProcess(false)
                        clearInterval(countIntervalId);
                        config.DATA = {};
                        handleResetBtn();
                        console.log(error);
                        SendBookDetails_MB();
                        handleClear();
                        unsetBetLoader();
                      });
 
                } catch (error) {
                    sendBetList();
                    SendBookDetails_MB();
                    setBetOnProcess(false)
                    clearInterval(countIntervalId);
                    setCashOut(false);
                    handleResetBtn();
                    handleClear();
                    console.error('Error fetching API data:', error);
                }
            }
        };
        encryptData();
    }, [receivedToken])
 
    const getTitleName = (type) => {
       if (type === "OVERS") {
          return "Session";
       } else if (type === "SINGLE_OVER") {
          return "Only Over";
       } else if (type === "BATSMAN") {
          return "W/P Market";
       } else if (type === "ODD_EVEN") {
          return "Odd Even";
       } else if (type === "WINNING_SEATS") {
          return "Winning Seats";
       } else if (type === "BALL_BY_BALL") {
          return "Ball by Ball";
       }
    }
 
    useEffect(() => {
       unsubscribeAll();
       setApiResponse();
       setsetMakerID();
       setMatchOdd();
       setBookmakerMarket();
       setFancyData();
       setsetMakerID([]);
       setKey(prevKey => prevKey + 1);
       fetchData(eventId);
       getData();
       getSubNotification();
    }, [eventId]);
 
    const getMyMinMax = (id) => {
       if (allMinMax && allMinMax.length > 0) {
          let data = allMinMax.find(item => item.marketId.toString() === id.toString());
          return (<><span>{`Min: ${data?.min_stake ? data?.min_stake : '0'} `}</span> <span>{`Max: ${data?.max_stake ? data?.max_stake : "0"}`}</span></>);
       }
    }
 
    const getMyBook = (id) => {
       if (usersideBook && usersideBook.length > 0) {
          let data = usersideBook.find(item => item.marketId.toString() === id.toString());
          return data?.book;
       }
    }
 
    const getMyBookcheck = (id) => {
       if (usersideBook && usersideBook.length > 0) {
          let data = usersideBook.find(item => item.marketId.toString() === id.toString());
          return data?.book > 0;
       }
    }
 
    const getMyMax = (id) => {
       if (allMinMax && allMinMax.length > 0) {
          let data = allMinMax.find(item => item.marketId.toString() === id.toString());
          return data?.max_stake;
       }
    }
 
    useEffect(() => {
       try{
           setStack(JSON.parse(stackArray));
       }catch(err){
           setStack(stackArray)
       }
   }, [stackArray]);
 
 
    const startWebSocket = () => {
       const marketTideTypes = ["TIED_MATCH"];
 
       const marketTypes = ["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN"];
       const marketKeys = ["OVER_UNDER_05", "OVER_UNDER_25", "OVER_UNDER_15"];
 
       let matchOddsArray = apiResponse?.matchData?.markets?.matchOdds || [];
       
       let selectTideMatch = [
          matchOddsArray.find((item) => marketTideTypes.includes(item.marketType))?.marketId
       ]
 
       let dataMOId = [
           matchOddsArray.find((item) => marketTypes.includes(item.marketType))?.marketId,
           ...marketKeys.map((key) => matchOddsArray.find((item) => item.marketType === key)?.marketId)
       ].filter(Boolean);
 
 
       const marketNames = ["Bookmaker", "Bookmaker 0 Commission", "To Win The Toss", "Special Maker"];
 
       let bookmakers = apiResponse?.matchData?.markets?.bookmakers || [];
 
       let dataBMId = [
         ...marketNames.map((name) => bookmakers.find((item) => item.marketName === name)?.marketId),
         bookmakers.find((item) => item.bettingType === "BOOKMAKER" && !marketNames.includes(item.marketName))?.marketId
       ].filter(Boolean);
 
 
       const ws = new WebSocket('wss://ag-api.maruti.dev/');
       wsRef.current = ws;
 
       ws.onopen = () => {
         console.log('11111--Connected to WebSocket server');
 
         for (let indexMo = 0; indexMo < dataMOId.length; indexMo++) {
           const element = dataMOId[indexMo];
           if (!subscribeChannels.current.includes(`${config.Topic_Match_Odds}${element}`)) {
             ws.send(JSON.stringify({ action: 'subscribe', topic: `${config.Topic_Match_Odds}${element}` }));
             subscribeChannels.current.push(`${config.Topic_Match_Odds}${element}`);
           }
         }
 
         for (let indexBM = 0; indexBM < dataBMId.length; indexBM++) {
           const element = dataBMId[indexBM];
           if (!subscribeChannels.current.includes(`${config.Topic_Bookmaker}${element}`)) {
             // console.log(element,"Bookmaker");
             ws.send(JSON.stringify({ action: 'subscribe', topic: `${config.Topic_Bookmaker}${element}` }));
             subscribeChannels.current.push(`${config.Topic_Bookmaker}${element}`);
           }
         }
 
         const topic = `${config.Topic_Fancy}${eventId}`;
 
         if (!subscribeChannels.current.includes(topic)) {
           ws.send(JSON.stringify({ action: 'subscribe', topic }));
           subscribeChannels.current.push(topic);
         } else {
           console.log(subscribeChannels.current, "Fancy already subscribe");
         }
 
         heartbeatInterval = setInterval(() => {
           if (ws.readyState === WebSocket.OPEN) {
             ws.send(JSON.stringify({ action: 'ping' }));
             // console.log("Pingggggggggg");
           } else if (ws.readyState === WebSocket.CLOSED) {
             clearInterval(heartbeatInterval);
             reconnectWebSocket(); // Function to reconnect
             console.log("reeeeeeeeeeeeeeeeeeeeeeTry");
           }
         }, 10000); // 10 seconds
       };
 
       ws.onmessage = (event) => {
       //   console.log('parsedData0');
       setTimeout(() => {
         const { topic, marketData } = JSON.parse(event.data);
         if (marketData) {
 
           const parsedData = JSON.parse(marketData);
           if (topic.startsWith(`${config.Topic_Bookmaker}`)) {
            // updateMarketWithParsedDataBM(topic, parsedData);
             setBookmakerMarket((prevBMData) => ({
               ...prevBMData,
               [`${topic.split('/').pop()}`]: parsedData,
             }));
           }
 
           if (topic.startsWith(`${config.Topic_Match_Odds}`)) {
             if (marketTideTypes.includes(parsedData.marketType)) {
                // updateMarketWithParsedDataTM(topic, parsedData);
                setTideMatch((prevMOData) => ({
                   ...prevMOData,
                   [`${topic.split('/').pop()}`]: parsedData,
                 }));
             }
             if (marketKeys.includes(parsedData.marketType)) {
                // updateMarketWithParsedDataUO(topic, parsedData);
                setUnderOver((prevMOData) => ({
                   ...prevMOData,
                   [`${topic.split('/').pop()}`]: parsedData,
                 }));
             } else if (!marketTideTypes.includes(parsedData.marketType)) {
                // updateMarketWithParsedDataMO(topic, parsedData);
                setMatchOdd((prevMOData) => ({
                   ...prevMOData,
                   [`${topic.split('/').pop()}`]: parsedData,
                 }));
             }
           }
 
           if (topic.startsWith(`${config.Topic_Fancy}`)) {
             let otherData = parsedData.filter((item) => item.status.trim() != 'CLOSED');
             let ids = marketID
             otherData.forEach((item) => {
               if (ids && !ids.includes(item.marketId.toString())) {
                   ids.push(item.marketId.toString());
               }
           });
 
           let marketIdArray = [
               ...selectTideMatch,
               ...dataMOId,
               ...dataBMId,
               ...ids
            ].filter(Boolean);
 
           setsetMakerID(marketIdArray);
           setFancyData(otherData);
 
           }
         }
        }, 0); // Non-blocking operation
       };
 
       ws.onclose = () => {
         console.log('11111--WebSocket disconnected');
         clearInterval(heartbeatInterval);
         reconnectWebSocket();
       };
 
       ws.onerror = (error) => {
         console.log('11111--WebSocket error:', error);
         clearInterval(heartbeatInterval);
         reconnectWebSocket();
       };
     };
 
     const reconnectWebSocket = () => {
        console.log('11111--Reconnecting WebSocket...');
        setTimeout(() => {
          requestIdleCallback(() => startWebSocket()); // Executes when the browser is idle
        }, 3000);
      };
      
 
     const unsubscribeAll = () => {
       if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
         subscribeChannels.current.forEach((topic) => {
           wsRef.current.send(JSON.stringify({ action: 'unsubscribe', topic }));
         });
         subscribeChannels.current = [];
       }
     };
 
     useEffect(() => {
        const handleVisibilityChange = () => {
          if (!document.hidden) {
            console.log("Tab is active again, reconnecting WebSocket...");
            startWebSocket();
          }
        };
    
        document.addEventListener("visibilitychange", handleVisibilityChange);
    
        return () => {
          document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
      }, []); // Runs only once on mount
 
     const parseFormattedNumber = (input) => {
       if (input == null || input === '') return 0;
     
       const str = input.toString().trim();
       const suffix = str.slice(-1).toUpperCase();
       const num = parseFloat(str);
     
       if (isNaN(num)) return 0;
     
       switch (suffix) {
         case 'K':
           return num * 1000;
         case 'M':
           return num * 1000000;
         case 'B':
           return num * 1000000000;
         default:
           return num; // Plain number or string with no suffix
       }
     };
 
    useEffect(() => {
       if (!apiResponse || !apiResponse.matchData || !apiResponse.matchData.markets) return;
       console.log(apiResponse, "responseresponseresponseresponseresponse");
       callScoreAPI(apiResponse);
       let { markets } = apiResponse.matchData;
       let selectedMatchOdds,selectedUnderOver,selectTideMatch;
 
       const overUnderMarkets = ["OVER_UNDER_05", "OVER_UNDER_15", "OVER_UNDER_25"];
       const generalMarkets = ["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN"];
 
       const marketTideTypes = ["TIED_MATCH"];
 
    //    if (mId && mId !== "" && mId != null) {
    //       selectedMatchOdds = markets.matchOdds?.filter(
    //          (item) =>
    //             generalMarkets.includes(item.marketType) &&
    //             item.marketId.toString() === mId.toString()
    //       ) || [];
 
    //       selectTideMatch = markets.matchOdds?.filter(
    //          (item) =>
    //             marketTideTypes.includes(item.marketType) &&
    //             item.marketId.toString() === mId.toString()
    //       ) || [];
 
    //       selectedUnderOver = markets.matchOdds?.filter(
    //          (item) =>
    //             overUnderMarkets.includes(item.marketType) &&
    //             item.marketId.toString() === mId.toString()
    //       ).sort(
    //          (a, b) => overUnderMarkets.indexOf(a.marketType) - overUnderMarkets.indexOf(b.marketType)
    //       ) || [];
    //    } else {
          selectedMatchOdds = markets.matchOdds?.filter(
             (item) => generalMarkets.includes(item.marketType)
          ) || [];
 
          selectTideMatch = markets.matchOdds?.filter(
             (item) => marketTideTypes.includes(item.marketType)
          ) || [];
 
          selectedUnderOver = markets.matchOdds?.filter(
             (item) => overUnderMarkets.includes(item.marketType)
          ).sort(
             (a, b) => overUnderMarkets.indexOf(a.marketType) - overUnderMarkets.indexOf(b.marketType)
          ) || [];
    //    }
 
 
       // if (mId && mId !== "" && mId != null) {
       //    selectedMatchOdds = markets.matchOdds?.filter(
       //       (item) =>
       //          (["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN", "OVER_UNDER_05", "OVER_UNDER_25", "OVER_UNDER_15","TIED_MATCH"].includes(item.marketType) && item.marketId.toString() === mId.toString())
       //    ) || [];
       // }else{
       //    selectedMatchOdds = markets.matchOdds?.filter(
       //       (item) =>
       //          ["MATCH_ODDS", "TOURNAMENT_WINNER", "WIN", "OVER_UNDER_05", "OVER_UNDER_25", "OVER_UNDER_15","TIED_MATCH"].includes(item.marketType)
       //    ) || [];
       // }
 
       let selectedBookmakers = markets.bookmakers.filter(
          (item) =>
             ["Bookmaker", "Bookmaker 0 Commission", "To Win The Toss", "Special Maker"].includes(item.marketName) ||
             item.bettingType === "BOOKMAKER" && !["Bookmaker", "Bookmaker 0 Commission", "To Win The Toss", "Special Maker"].includes(item.marketName)
       );
 
 
       let fancyMarketsArray = markets.fancyMarkets.filter((item) =>
          ["OVERS", "SINGLE_OVER", "BATSMAN", "ODD_EVEN", "WINNING_SEATS", "BALL_BY_BALL","OTHER"].includes(item.category)
       );
 
       let marketIdArray = [
          ...selectedMatchOdds.map(item => item.marketId),
          ...selectTideMatch.map(item => item.marketId),
          ...selectedUnderOver.map(item => item.marketId),
          ...selectedBookmakers.map(item => item.marketId),
          ...fancyMarketsArray.map(item => item.marketId)
       ].filter(Boolean);
 
       selectedMatchOdds.forEach((item) => {
        // updateMarketWithItemMO(item);
          setMatchOdd((prevMOData) => ({
             ...prevMOData,
             [`${item.marketId}`]: item,
          }));
       });
       selectTideMatch.forEach((item) => {
        // updateMarketWithItemTM(item);
          setTideMatch((prevMOData) => ({
             ...prevMOData,
             [`${item.marketId}`]: item,
          }));
       });
       // console.log(selectedUnderOver,"selectedUnderOverselectedUnderOver");
 
 
       selectedUnderOver.forEach((item) => {
        // updateMarketWithItemUO(item);
          setUnderOver((prevMOData) => ({
             ...prevMOData,
             [`${item.marketId}`]: item,
          }));
       });
 
       selectedBookmakers.forEach((item) => {
        // updateMarketWithItemBM(item);
          setBookmakerMarket((prevMOData) => ({
             ...prevMOData,
             [`${item.marketId}`]: item,
          }));
       });
 
       setsetMakerID(marketIdArray);
       setFancyData(fancyMarketsArray);
       startWebSocket();
       SendBookDetails_MB();
    }, [apiResponse]);
 
    const fetchData = async (id) => {
        try {
            const myHeaders = new Headers({
                "Content-Type": "application/json"
            });
    
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/api/v1/games/getInPlayMatchData?id=${id}`,
                {
                    method: "GET",
                    headers: myHeaders,
                    redirect: "follow"
                }
            );
    
            const paresData = await response.json();
            setApiResponse(paresData);
        } catch (error) {
            console.error("Fetch Error:", error);
        }
    };
 
    const formatDate = (eventDate) => {
       const date = new Date(eventDate);
 
       return new Intl.DateTimeFormat('en-GB', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false,
          timeZoneName: 'short'
       }).format(date);
    };
 
    const validation = (price) => {
       if (price &&
          price !== '-' &&
          price !== 0) {
          return true
       } else {
          return false
       }
    }
 
    const validationBM = (price) => {
       if (price &&
          price != '-' &&
          price != 0) {
          return true
       } else {
          return false
       }
    }
 
    const formatNumber = (num) => {
       if (num >= 10000000) {
          return (num / 10000000).toFixed(2) + 'Cr'; // Crore
       } else if (num >= 100000) {
          return (num / 100000).toFixed(2) + 'L'; // Lakh
       } else if (num >= 1000) {
          return (num / 1000).toFixed(2) + 'K'; // Thousand
       } else {
          return num.toString(); // Less than 1000
       }
    };
 
    const formatNumberNotFiex = (num) => {
       if (num >= 10000000) {
          return (num / 10000000) + 'Cr'; // Crore
       } else if (num >= 100000) {
          return (num / 100000) + 'L'; // Lakh
       } else if (num >= 1000) {
          return (num / 1000) + 'K'; // Thousand
       } else {
          return num.toString(); // Less than 1000
       }
    };
 
    const getBoxValue = (runner) => {
       return <>
          {validation(runner.price) ? runner.price : getLock()}
          <small>
             {validation(runner.size) ? formatNumber(runner.size) : getLock()}
          </small>
       </>
    }
 
    const getBMBoxValue = (runner,marketId) => {
       return <>
          {validation(runner.price) ? runner.price : getLock()}
       </>
    }
 
    const getLock = () => {
       // <img src='../images/lock.svg' alt='as'/>
       return <i className="fa fa-lock"></i>
    }
 
    const checkFancyAdminIsSuspend = (id) =>{
       if (allMinMax && allMinMax.length > 0) {
           let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
           return data?.resumesuspendstatus;
           }else{
               return false;
           }
   }
 
    const fancySuspend = (session) =>{
       if (checkFancyAdminIsSuspend(session.marketId)) {
           if(session.status !== "OPEN"){
               return <div className="suspended">{session.status}</div>
           }
       }else{
           return <div className="suspended">SUSPENDED</div>
       }
   }
 
   const isFancySuspend = (session) =>{
    if (checkFancyAdminIsSuspend(session.marketId)) {
        if(session.status !== "OPEN"){
            return true;
        }else{
            return false;
        }
    }else{
        return true;
    }
 }
 
    // Effect for 'getmarketminmaxdata'
    useEffect(() => {
       if (!isConnected || !apiResponse) return;
 
     // Call once when dependencies change
 
       const sendMarketUpdates = () => {
          let data;
          let userData = sessionStorage.getItem('userId')
          if (userData) {
             data = {
                userId: sessionStorage.getItem('userId'),
                marketIds: marketID,
                eventId: eventId
             };
          } else {
             data = {
                userId: '64db25fa1617ac95db367a0d',
                marketIds: marketID,
                eventId: eventId
             };
 
          }
          // console.log(marketID, 'datdatdatdatdtadad')
          sendMessage('getmarketminmaxdata', data);
       };
 
       sendMarketUpdates(); // Send immediately
       const intervalId = setInterval(sendMarketUpdates, 3000);
 
       return () => { clearInterval(intervalId) };
    }, [apiResponse, isConnected, marketID]);
 
    const checkAdminIsSuspend = (id) => {
       if (allMinMax && allMinMax.length > 0) {
          let data = allMinMax.find(item => item.marketId.toString() === id.toString());
          return data?.resumesuspendstatus;
       } else {
          return false;
       }
    }
 
    const getSuspendedMatchOdds = (status, matchOdd) => {
       if (!checkAdminIsSuspend(matchOdd.marketId)) {
          if (matchOdd.status == "OPEN") {
             if (status != "ACTIVE") {
                return <div className="suspended">{status}</div>
             }
          } else {
             return <div className="suspended">{matchOdd.status}</div>
          }
       } else {
          return <div className="suspended">Suspended</div>
       }
    }
 
    const checkSuspendedMatchOdds = (status, matchOdd) => {
        if (!checkAdminIsSuspend(matchOdd.marketId)) {
           if (matchOdd.status == "OPEN") {
              if (status != "ACTIVE") {
                 return true;
              }else {
                return false;
              }
           } else {
              return true;
           }
        } else {
           return true;
        }
     }

    const getSuspendedMatchOddsClass = (status, matchOdd) => {
       if (!checkAdminIsSuspend(matchOdd.marketId)) {
          if (matchOdd.status == "OPEN") {
             if (status != "ACTIVE") {
                return "lock"
             }
          } else {
             return "lock"
          }
       } else {
          return "lock"
       }
    }
 
    const setProfitloss = (marketId,runnerId) => {
       return <span className={`${ profitLossData[`${marketId}_${runnerId}`] > 0 ? "green-txt" : profitLossData[`${marketId}_${runnerId}`] < 0 ? "red-txt" : "" } book-value`}>{profitLossData[`${marketId}_${runnerId}`] || ""}</span>
    }
 
    const checkMaxOdds = (id,price) =>{
       if (allMinMax && allMinMax.length > 0) {
           let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
          //  if (data.marketId.toString() == 12926696 ) {
          //    console.log(data,"data?.max_odd");
          //  }
           if (data?.max_odd == 0) {
                return true;
           }else{
             return data?.max_odd > price;
           }
           }else{
               return false;
           }
    }
 
    const getSuspendedBookmaker = (status, bookmakerMarket1) => {
       if (!checkAdminIsSuspend(bookmakerMarket1.marketId)) {
          if (bookmakerMarket1.status === "OPEN") {
             if (status !== "ACTIVE") {
                return <div className="suspended">{status}</div>
             }
          } else {
             return <div className="suspended">{bookmakerMarket1.status}</div>
          }
       } else {
          return <div className="suspended">SUSPENDED</div>
       }
    }
 
    const getSuspendedBookmakerClass = (status, bookmakerMarket1) => {
       if (!checkAdminIsSuspend(bookmakerMarket1.marketId)) {
          if (bookmakerMarket1.status === "OPEN") {
             if (status !== "ACTIVE") {
                return "lock";
             }
          } else {
             return "lock";
          }
       } else {
          return "lock";
       }
    }
 
    function customSort(a, b) {
       const getNumber = (str) => {
           const match = str.match(/^(\d+)/); // Match leading numeric value
           return match ? parseInt(match[0], 10) : Infinity; // Use Infinity for non-numeric values
       };
 
       const numA = getNumber(a.marketName);
       const numB = getNumber(b.marketName);
 
       if (numA !== numB) {
           return numA - numB; // Sort numerically first
       }
 
       return a.marketName.localeCompare(b.marketName); // If numbers are equal, sort alphabetically
   }
 
   const handleResetBtn = () => {
    SendBookDetails_MB();
    setIsBetSlipOpen(false);
    setBetsData({
        eventId: '',
        marketId: '',
        stake: 0,
        betType: '',
        selectionName: '',
        odds: '',
        secId: '',
        marketData:{},
        isFancy:''
    });
 }
 
 const formatNumberinStack = (num) => {
    if (num >= 1000000000) {
      return (num / 1000000000) + 'B'; // Billion
    } else if (num >= 1000000) {
      return (num / 1000000) + 'M'; // Million
    } else if (num >= 1000) {
      return (num / 1000) + 'K'; // Thousand
    } else {
      return num; // Less than 1000
    }
  };
 
  const handleClear = () => {
    setCurrentBetSlip('');
    handleResetBtn();
    unsetBetLoader();
    setBetsData((prev) => ({
      ...prev,
      stake: "0", // Setting stake to '0'
    }));
  };
 
  const handlePlceBets = () => {
    clearInterval(countIntervalId);
    setBetOnProcess(true);
    let user = JSON.parse(sessionStorage.getItem('userinfo'));
    sendMessage("createToken",{userName:user.userName});
 }
 
 const addValue = (item,check) => {
    if (check) {
        updateBook(betsData.stake,Number(item)+Number(betsData.stake))
        setBetsData(prev => ({
            ...prev,
            stake: (parseFloat(prev.stake) + Number(item))
        }))
    }else{
            updateBook(betsData.stake,Number(item))
            setBetsData(prev => ({
                ...prev,
                stake: Number(item)
            }))
    }
 }

 const allValue = () => {
    let userinfo = sessionStorage.getItem('balance');
    if (userinfo !== null) {
        let data = JSON.parse(userinfo);
        return (data.availableBalance - data.totalExposure).toFixed(2);
    }else{
        return 0;
    }
};

 const convertToOriginalValue = (shorthand) => {
    // Ensure shorthand is a string
    if (typeof shorthand !== 'string') {
        return shorthand; // Return the value as is if it's not a string
    }

    const value = parseFloat(shorthand); // Extract numeric part
    if (shorthand.toUpperCase().endsWith('K')) {
        return value * 1_000; // Multiply by 1,000 for 'K'
    } else if (shorthand.toUpperCase().endsWith('M')) {
        return value * 1_000_000; // Multiply by 1,000,000 for 'M'
    }
    return value; // Return the numeric value if no suffix
};

 const PlusValue = () => {
    const valueToAdd = 100; // Always add 100 on each click

    setBetsData(prev => {
        const oldValue = prev.stake ? parseFloat(prev.stake) : 0;
        const updatedStake = oldValue + valueToAdd; // Increment by 100

        updateBook(oldValue, updatedStake);

        return {
            ...prev,
            stake: updatedStake
        };
    });
};



const subtractValue = () => {
    const valueToSubtract = 100; // Always subtract 100

    setBetsData(prev => {
        const oldValue = prev.stake ? parseFloat(prev.stake) : 0;
        const newValue = oldValue - valueToSubtract;

        if (newValue > 0) {
            updateBook(oldValue, newValue);
        } else {
            SendBookDetails_MB();
        }

        return {
            ...prev,
            stake: newValue < 0 ? 0 : newValue // Ensure stake never goes negative
        };
    });
};


 
 const handleIncrementOdds = (event) => {
    let newOdds =(parseFloat(betsData.odds || "0") + 0.01).toFixed(2)
    setBetsData(prevState => ({
        ...prevState,
        odds: newOdds
    }));
 };
 
 const handleDecrementOdds = (event) => {
    let newOdds =(parseFloat(betsData.odds || "0") - 0.01).toFixed(2)
    setBetsData(prevState => ({
        ...prevState,
        odds: newOdds
    }));
 };
 
 const handleClose = () => {
    setFancyBookPopup(false);
 }
 
   const handleOnBackClick = (runner,betType,marketId,odds,isFancy,matchOdd) => {
    SendBookDetails_MB();
    
       if (!betOnProcess){
          setIsBetSlipOpen(true);
          if (isFancy === config.isNotfancy) {
             config.DATA = {
                   eventId: eventId,
                   marketId: `${marketId}`,
                   stake: 0,
                   betType: betType,
                   selectionName: runner.runnerName,
                   odds: odds,
                   secId: `${runner.runnerId}`,
                   marketData:matchOdd,
                   marketName:matchOdd?.marketName,
                   isFancy:isFancy
             }
             setBetsData({
                   eventId: eventId,
                   marketId: `${marketId}`,
                   stake: 0,
                   betType: betType,
                   selectionName: runner.runnerName,
                   odds: odds,
                   secId: `${runner.runnerId}`,
                   marketData:matchOdd,
                   marketName:matchOdd?.marketName,
                   isFancy:isFancy
             });
             setCurrentBetSlip(`${marketId}_${runner.runnerId}`);
          }else{
             config.DATA = {
                   eventId: eventId,
                   marketId: `${marketId}`,
                   stake: 0,
                   betType: betType,
                   selectionName: runner.marketName,
                   odds: betType === config.back ? runner.yesRate : runner.noRate,
                   rate: betType === config.back ? runner.yesValue : runner.noValue,
                   marketName:getTitleName(runner?.category),
                   marketType:getTitleName(runner?.category),
                   isFancy:isFancy
             }
 
             setBetsData({
                   eventId: eventId,
                   marketId: `${marketId}`,
                   stake: 0,
                   betType: betType,
                   selectionName: runner.marketName,
                   odds: betType === config.back ? runner.yesRate : runner.noRate,
                   rate: betType === config.back ? runner.yesValue : runner.noValue,
                   marketName:getTitleName(matchOdd?.category),
                   marketType:getTitleName(matchOdd?.category),
                   isFancy:isFancy
             });
             setCurrentBetSlip(`${marketId}`);
          }
          if (sessionStorage.getItem('loggedIn') || loggedIn) {
            if (isOneClicked === "true") {
                clearInterval(countIntervalId);
                setBetOnProcess(true);
                setBetLoder();
                let user = JSON.parse(sessionStorage.getItem('userinfo'));
                sendMessage("createToken",{userName:user.userName});
            }
       }else{
          console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
       }
    }else{

    }
    }
 
    const handleCashOutBM = (id,e) => {
       e.stopPropagation();
       let marketId = id;
       let userinfo = sessionStorage.getItem('userinfo');
       let eventID = eventId;
       if (userinfo && eventID) {
           userinfo = JSON.parse(userinfo);
           sendMessage('cashOOutBm', { id: marketId, user: userinfo, eventID });
       }
   };
 
    const handleCashOutMO = (id,e) => {
       e.stopPropagation();
       let marketId = id;
       let userinfo = sessionStorage.getItem('userinfo');
       let eventID = eventId;
       if (userinfo && eventID) {
           userinfo = JSON.parse(userinfo);
           sendMessage('cashOOut', { id: marketId, user: userinfo, eventID });
       }else{
       }
   };
 
    const isShowcashout = (id) => {
       if (allMinMax && allMinMax.length > 0) {
           let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
           return data?.isshowcashout
       }else{
           return false;
       }
   }
    const isCommission = (id) => {
       if (allMinMax && allMinMax.length > 0) {
           let data = allMinMax.find(item=>item.marketId.toString() === id.toString());
           return data?.commissionstatus
       }else{
           return false;
       }
   }
 
   const getSubNotification = async () => {
    try {
        const data = JSON.stringify({ eventId });

        const myHeaders = new Headers({
            "Content-Type": "application/json"
        });

        const response = await fetch(
            `${process.env.REACT_APP_BASE_URL}/api/v1/notification/getmarketNotitfication`,
            {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: data
            }
        );

        const paresData = await response.json();

        setMyNotification(paresData?.notifications);
        console.log(paresData?.notifications, "paresData?.notifications");
    } catch (error) {
        console.error("Fetch Error:", error);
    }
};

 
   const handleShow = (marketId) => {
    setFancyBookPopup(true)
 
    let userinfo = sessionStorage.getItem('userinfo');
    if (userinfo && marketId) {
        userinfo = JSON.parse(userinfo);
        console.log(marketId,"marketIdmarketIdmarketIdmarketId");
        sendMessage('getFancyBookDATAuserSide', { id: marketId, user: userinfo });
    }
 }
 
 const getSportType = () => {
    if (apiResponse?.matchData?.sportId.toString() === "7" || apiResponse?.matchData?.sportId.toString() === '4339') {
        return true;
    }else{
        return false;
    }
 }
 
 const checkData = (a,b) =>{
    console.log(a,b,"aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
    
 }
 
 function usePrevious(value) {
   const ref = useRef();
 
   useEffect(() => {
     ref.current = value;
   }, [value]);
 
   return ref.current;
 }
 
 const getNotification = (id) =>{   
    if (myNotification && myNotification.length > 0) {
        let item = myNotification.find(noti => noti.marketId == id)?.notifications;
        if (item) {
            return <div className="notifi" style={{ fontSize:'12px', color:"#AAAFB5", cursor: "default" }}>{item}</div>;
        } else{
            return '';
        } 
    }else{
        return '';
    }
 } 
 useEffect(() => {
    document.body.classList.add("exchange_inPlay");
    return () => {
      document.body.classList.remove("exchange_inPlay");
    };
  }, []);

    const checkFancy = (data) => {
        return fancyData?.filter((item) => item.category === data).length > 0;
    }
    const grulesHandle = (e)=>{
        e.stopPropagation();
        setGrulesPopup(true);
    }
    const gruleshandleClose = ()=>{
        setGrulesPopup(false);
    }

    const mutliMarketAddRemove = async (marketID, evenID, e) => {
        e.stopPropagation();
    
        try {
            const myHeaders = new Headers({
                "Content-Type": "application/json",
                "Authorization": `Bearer ${sessionStorage.getItem("token")}`
            });
    
            const raw = JSON.stringify({ marketId: marketID, eventId: evenID });
    
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/armultimarket`, {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            });
    
            const paresData = await response.json();
    
            if (response.ok) {
                setMultimarketArray(paresData.marketId);
            } else {
                console.error("Error:", paresData);
            }
        } catch (error) {
            console.error("Fetch Error:", error.message);
        }
    };
    

    const isMarketIdPresent = (multimarketArray, marketId) => {
        return multimarketArray.includes(marketId);
    };

    const removeLastDigit = (event) => {
        let oldValue = betsData.stake
        setBetsData((prev) => ({
            ...prev,
            stake: prev.stake !== undefined 
                ? (String(prev.stake).slice(0, -1) || '0') 
                : '0'
        }));
        
        if(oldValue){
            let newValue = String(oldValue).slice(0, -1);
            updateBook(oldValue, newValue)
        }else{
            SendBookDetails_MB();
        }
    };

    useEffect(() => {
            let timer;
            if (isBetLoader) {
              timer = setInterval(() => {
                loaderCounting(prevSeconds => prevSeconds + 1);
              }, 1000);
            } else {
              loaderCounting(0);
              clearInterval(timer);
            }
            return () => clearInterval(timer);
          }, [isBetLoader]);

    const incrementValue = (increment) => {
        let oldValue = betsData.stake
        setBetsData((prev) => ({
            ...prev,
            stake: prev.stake ? Number(prev.stake) + increment : increment
        }));
        let newValue = parseFloat(oldValue + increment)

        updateBook(oldValue, newValue)
    };

    const getbetSlip = (isfancy,marketId,runnerId,check) => {        
        let checkisFancy  = isfancy === config.fancy ? `${marketId}` : `${marketId}_${runnerId}`;
        
        if(check && currentBetSlip === `${checkisFancy}`){
            debugger;
            setCurrentBetSlip('');
        }

        return <div id={`${checkisFancy}`} key={`${checkisFancy}`} className={`betslip-wraper ${currentBetSlip === `${checkisFancy}` ? 'open' : ''} `}>

        <div className={`betslip ${currentBetSlip === `${checkisFancy}` ? 'active' : ''} ${betsData.betType === config.back ? 'back' : 'lay'}`}>
        <div className="close-btn" onClick={handleClear}>×</div>
            <div className="betslip-top">
        <div className="bet-selection-name" >Bet on : {betsData.selectionName} @{betsData.isFancy === config.isNotfancy ? betsData.odds : betsData.rate}</div>
        <div className="bet-profit"> </div>
        <div className="betslip-odds betslip-stake">
            <strong>Odds</strong>
            <div className='input-group'>
                <span onClick={handleDecrementOdds}>-</span>
                <input type="text" value={betsData.isFancy === config.isNotfancy ? betsData.odds : betsData.rate} />
                <span onClick={handleIncrementOdds}>+</span>
            </div>
        </div>
        <div className="betslip-stake">
            <strong>Stake</strong>
            <div className="input-group">
                <span className="minus" onClick={subtractValue}>-</span>
                <input type="text" value={betsData.stake} onChange={(e) => {
                    let inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                        updateBook(betsData.stake, inputValue);
                        setBetsData((prev) => prev.stake !== inputValue ? { ...prev, stake: inputValue } : prev );
                    }
                }}  className="set-stake-form-input"  aria-label="Last name" autoFocus="" maxLength="8" />
                <span className="plus" onClick={PlusValue}>+</span>
            </div>
        </div>
            </div>
            <div className="betslip-placebutton">
                <div className="price-btns">
                {Array.isArray(stack) && stack.map((item,index) => (
                        <span key={index} id={`${item}`} onClick={()=> addValue(item,true)}>{formatNumberinStack(item)}</span>
                    )) }
                    <span id="1000" className="MAX" onClick={()=>addValue(`${convertToOriginalValue(getMyMax(betsData.marketId))}`,false)}>MAX</span>
                    <span id="1000" className="MAX" onClick={()=>addValue(`${allValue()}`,false)}>All</span>
                </div>
                <div className="betplace-btn">
                {loggedIn || sessionStorage.getItem('userId') ? <button className="place-bet" onClick={()=>{
                    setBetLoder()
                    setBetOnProcess(true);
                    let user = JSON.parse(sessionStorage.getItem('userinfo'));
                    sendMessage("createToken",{userName:user.userName});
                }}>Place Bet</button> :  <button className="login-btn" onClick={openPopup} >Login to continue</button>}
                </div>
            </div>
        </div>
        
        <div className={`betslip_mobileview ${currentBetSlip === `${checkisFancy}` ? 'active' : ''} ${betsData.betType === config.back ? 'back' : 'lay'}`}>
        <div className="close-btn" onClick={handleClear}>×</div>
        <table className="eventdetails">
                                                    <tbody>
                                                        <tr>
                                                            <td>
                                                                <div className='plus-minus-wraper'>
                                                                <div className='plus-minus'>
                                                                    <span onClick={(event) => handleDecrementOdds(event)}>-</span>
                                                                    <input type="text" value={betsData.isFancy === config.isNotfancy ? betsData.odds : betsData.rate} />
                                                                    <span onClick={(event) => handleIncrementOdds(event)}>+</span>
                                                                </div>
                                                                <div className='plus-minus'>
                                                                    <span >-</span>
                                                                    <input type="text" value={betsData.stake} className="set-stake-form-input" onChange={(e) => {
                    let inputValue = e.target.value;
                    if (/^\d*\.?\d*$/.test(inputValue)) {
                        updateBook(betsData.stake, inputValue);
                        setBetsData((prev) => prev.stake !== inputValue ? { ...prev, stake: inputValue } : prev );
                    }
                }}  aria-label="Last name" autoFocus="" maxLength="8" />
                                                                    <span >+</span>
                                                                </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="11" className='mbet-slip'>
                                                                <div className="mbet-slip-wraper">
                                                                {Array.isArray(stack) && stack.map((item,index) => (
                                                                    <div key={index} id={`${item}`} className="odds-value" onClick={(event) => addValue(`${item}`,event)}>{formatNumberinStack(item)}</div>
                                                                )) }
                                                                    {/* <div className="odds-value max" onClick={(event)=>addAllValue(`${convertToOriginalValue(receivedBookmaker?.finalResult?.[0]?.max_stake)}`,event)} id="10000">MAX</div> */}
                                                                    {/* <div className="odds-value all" onClick={(event)=>addAllValue(`${allValue()}`,event)} id="98941.80">ALL IN</div> */}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr className="numbering">
                                                            <td colSpan="11">
                                                                <table>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td><span onClick={(event) => incrementValue('1',event)} id="1">1</span></td>
                                                                            <td><span onClick={(event) => incrementValue('2',event)} id="2">2</span></td>
                                                                            <td><span onClick={(event) => incrementValue('3',event)} id="3">3</span></td>
                                                                            <td><span onClick={(event) => incrementValue('4',event)} id="4">4</span></td>
                                                                            <td><span onClick={(event) => incrementValue('5',event)} id="5">5</span></td>
                                                                            <td><span onClick={(event) => incrementValue('6',event)} id="6">6</span></td>
                                                                            <td rowSpan="2"><span className="back-span" onClick={(event) => removeLastDigit(event)}><img alt="" src={betslipclosearrow}/></span></td>
                                                                        </tr>
                                                                        <tr>
                                                                            <td><span onClick={(event) => incrementValue('7',event)} id="7">7</span></td>
                                                                            <td><span onClick={(event) => incrementValue('8',event)} id="8">8</span></td>
                                                                            <td><span onClick={(event) => incrementValue('9',event)} id="9">9</span></td>
                                                                            <td><span onClick={(event) => incrementValue('0',event)} id="0">0</span></td>
                                                                            <td><span onClick={(event) => incrementValue('00',event)} id="double0">00</span></td>
                                                                            {/* <td><span onClick={(event) => incrementValue('000',event)} id="dot">000</span></td> */}
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </td>
                                                        </tr>
                                                        <tr className="bet-btns">
                                                            <td colSpan="11">
                                                                <div className="btn-wraper">
                                                                    <button className="btn cancel-bet" onClick={handleClear}>CANCEL</button>
                                                                    {loggedIn || sessionStorage.getItem('userId') ? <button className="btn place-bet" onClick={(event) =>{
                                                                        setBetLoder()
                                                                        setBetOnProcess(true);
                                                                        let user = JSON.parse(sessionStorage.getItem('userinfo'));
                                                                        sendMessage("createToken",{userName:user.userName});
                                                                        // onBetClick({eventid : receivedBookmaker?.finalResult?.[0]?.eventId , marketId :receivedBookmaker?.finalResult?.[0].marketId,stake: priceGet,bklyClassValue, selectionName :oddItem.runnerName, secId :oddItem.runnerId, oddsValue})
                                                                    }
        
                                                                        }>Place Bet</button> :  <button onClick={openPopup} className="btn place-bet">Login to continue</button>}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
        </div>
        {isBetLoader ?
                                    <div className="loader-sec loading">
                                        Placing Your Bet, Please Wait <div className='loader-box'><span className='loading-number'>{String(loaderCounter).padStart(2, '0')}</span><span className='loader'></span></div>
                                        </div> : ''}
        </div>;
    }

    const getData = async () => {
        setTimeout(async () => {
            const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
            "whiteLabelName": window.location.hostname
        });

        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
        };

        fetch(`${process.env.REACT_APP_BASE_URL}/getGameRules`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setGameRule(data);
            })
            .catch((error) => {
                console.log("Error fetching data:", error);
            });
        }, 0); // Offload work
    };

  return (
    <>
            <Container size='full'>
            {matchStatuss && matchStatuss === 1 ?
                <div className='content-w-sidebar exchange-inner-page'>
                    <div className='left-content'>
                        {matchCheck != 'IN_PLAY' && apiResponse ? <div className='live-score'>
                        <div className="heading">
                            <div className="heading-text sport-name"><span className='series-name'>{apiResponse?.matchData?.competitionName}</span> <span className='seprator'>/</span> <strong>{apiResponse?.matchData?.eventName}</strong></div>
                            <div className="heading-text time"><i className="fa-regular fa-clock"></i> {apiResponse?.matchData?.openDate && (
                            <>
                                {new Date(apiResponse?.matchData?.openDate).toLocaleDateString('en-US', {
                                month: 'long',
                                day: 'numeric',
                                year: 'numeric',
                                })}
                                {" at "}
                                {new Date(apiResponse?.matchData?.openDate).toLocaleTimeString('en-US', {
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: true,
                                })}
                            </>
                            )}</div></div>
                        </div>:'' }
                        {(matchCheck === 'IN_PLAY' && initialized?.current && scoreAPICall) ? <Scoreboard eventId={eventId} scoreboardData={apiResponse?.matchData} receivedBetlistData={receivedBetlistData.bets.bets} url={tvUrl} scoreUrl={scoresUrl} /> : 
                        ''}
                        
                        <div className='match-data-wraper'>
                        
                        {apiResponse && matchOdd && 
                            Object.entries(matchOdd).map(([key, value]) => {
                                return (
                                    <div id={key} className='sport-all-data inner-match-list'>
                                        <div className='match-wrapper'>
                                            <Accordion transition transitionTimeout={350}>
                                            <AccordionItem initialEntered header={
                                            <div className={`heading ${sessionStorage.getItem('userId') ? 'w-star':''}`}>
                                            <div className='heading-text sport-name'>
                                            {value?.marketName} <span className='rulespopup-btn' onClick={(e)=>grulesHandle(e)}><i className="fa-solid fa-circle-info"></i></span>
                                            </div>
                                            <div className='heading-text sport-name'>
                                            {getMyMinMax(value.marketId)}
                                            </div>
                                            {sessionStorage.getItem('userId') ? (
                                                isMarketIdPresent(multimarketArray,value.marketId) ? (<svg className='star-icon' onClick={(e)=>mutliMarketAddRemove(value.marketId,eventId,e)} xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                        <path d="M12.3834 1.13606C13.0434 -0.201277 14.9514 -0.201277 15.6114 1.13606L18.7554 7.50672L25.7861 8.52806C27.2621 8.74139 27.8514 10.5574 26.7834 11.5987L25.5754 12.7761C24.0802 11.9352 22.3691 11.557 20.6588 11.6894C18.9485 11.8217 17.3159 12.4586 15.9678 13.5194C14.6198 14.5802 13.6168 16.0172 13.086 17.6484C12.5552 19.2797 12.5204 21.0317 12.9861 22.6827L7.71006 25.4561C6.39006 26.1494 4.84606 25.0294 5.09672 23.5587L6.29806 16.5574L1.21139 11.5974C0.143391 10.5574 0.732724 8.74272 2.20872 8.52806L9.23939 7.50672L12.3834 1.13606ZM28.6634 20.3334C28.6634 18.3885 27.8908 16.5232 26.5155 15.1479C25.1402 13.7727 23.275 13.0001 21.3301 13.0001C19.3851 13.0001 17.5199 13.7727 16.1446 15.1479C14.7693 16.5232 13.9967 18.3885 13.9967 20.3334C13.9967 22.2783 14.7693 24.1436 16.1446 25.5188C17.5199 26.8941 19.3851 27.6667 21.3301 27.6667C23.275 27.6667 25.1402 26.8941 26.5155 25.5188C27.8908 24.1436 28.6634 22.2783 28.6634 20.3334ZM21.9967 21.0001L21.9994 24.3374C21.9994 24.5142 21.9292 24.6838 21.8041 24.8088C21.6791 24.9338 21.5095 25.0041 21.3327 25.0041C21.1559 25.0041 20.9863 24.9338 20.8613 24.8088C20.7363 24.6838 20.6661 24.5142 20.6661 24.3374V21.0001H17.3261C17.1492 21.0001 16.9797 20.9298 16.8547 20.8048C16.7296 20.6798 16.6594 20.5102 16.6594 20.3334C16.6594 20.1566 16.7296 19.987 16.8547 19.862C16.9797 19.737 17.1492 19.6667 17.3261 19.6667H20.6661L20.6647 16.3321C20.6647 16.1552 20.735 15.9857 20.86 15.8607C20.985 15.7356 21.1546 15.6654 21.3314 15.6654C21.5082 15.6654 21.6778 15.7356 21.8028 15.8607C21.9278 15.9857 21.9981 16.1552 21.9981 16.3321V19.6654H25.3274C25.5042 19.6654 25.6738 19.7356 25.7988 19.8607C25.9238 19.9857 25.9941 20.1552 25.9941 20.3321C25.9941 20.5089 25.9238 20.6784 25.7988 20.8035C25.6738 20.9285 25.5042 20.9987 25.3274 20.9987H21.9994L21.9967 21.0001Z" fill="#182EA6"></path>
                                                    </svg>
                                                ) :(<svg onClick={(e)=> mutliMarketAddRemove(value.marketId,eventId,e)} className='star-icon' xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                        <path d="M12.3839 1.136C13.0439 -0.201338 14.9519 -0.201338 15.6119 1.136L18.7559 7.50666L25.7865 8.528C27.2625 8.74133 27.8519 10.5573 26.7839 11.5987L25.5772 12.7747C24.9405 12.4162 24.2609 12.1402 23.5545 11.9533L25.0972 10.4493L18.3639 9.47066C18.0751 9.42853 17.8009 9.31683 17.5649 9.14518C17.3289 8.97353 17.1382 8.74708 17.0092 8.48533L13.9972 2.38666L10.9865 8.48533C10.8575 8.74708 10.6668 8.97353 10.4308 9.14518C10.1948 9.31683 9.92064 9.42853 9.63188 9.47066L2.89855 10.4493L7.77055 15.1987C8.19455 15.612 8.38788 16.208 8.28788 16.792L7.13855 23.4973L12.6705 20.5893C12.6905 21.312 12.8012 22.012 12.9879 22.6813L7.71055 25.456C6.39055 26.1493 4.84655 25.0293 5.09721 23.5587L6.29855 16.5573L1.21188 11.5973C0.143879 10.5573 0.733212 8.74266 2.20921 8.528L9.23988 7.50666L12.3839 1.136ZM28.6665 20.3333C28.6665 18.3884 27.8939 16.5231 26.5187 15.1479C25.1434 13.7726 23.2781 13 21.3332 13C19.3883 13 17.523 13.7726 16.1478 15.1479C14.7725 16.5231 13.9999 18.3884 13.9999 20.3333C13.9999 22.2783 14.7725 24.1435 16.1478 25.5188C17.523 26.894 19.3883 27.6667 21.3332 27.6667C23.2781 27.6667 25.1434 26.894 26.5187 25.5188C27.8939 24.1435 28.6665 22.2783 28.6665 20.3333ZM21.9999 21L22.0012 24.3373C22.0012 24.5141 21.931 24.6837 21.8059 24.8087C21.6809 24.9338 21.5114 25.004 21.3345 25.004C21.1577 25.004 20.9882 24.9338 20.8631 24.8087C20.7381 24.6837 20.6679 24.5141 20.6679 24.3373V21H17.3279C17.1511 21 16.9815 20.9298 16.8565 20.8047C16.7314 20.6797 16.6612 20.5101 16.6612 20.3333C16.6612 20.1565 16.7314 19.9869 16.8565 19.8619C16.9815 19.7369 17.1511 19.6667 17.3279 19.6667H20.6665V16.332C20.6665 16.1552 20.7368 15.9856 20.8618 15.8606C20.9868 15.7356 21.1564 15.6653 21.3332 15.6653C21.51 15.6653 21.6796 15.7356 21.8046 15.8606C21.9296 15.9856 21.9999 16.1552 21.9999 16.332V19.6653H25.3292C25.506 19.6653 25.6756 19.7356 25.8006 19.8606C25.9256 19.9856 25.9959 20.1552 25.9959 20.332C25.9959 20.5088 25.9256 20.6784 25.8006 20.8034C25.6756 20.9284 25.506 20.9987 25.3292 20.9987L21.9999 21Z" fill="#182EA6"/>
                                                    </svg>
                                                )
                                            ) :'' }
                                        </div>}>

                                        <div className='heading match-heading'>
                                            <div className='heading-text sport-name'>
                                                Market
                                            </div>

                                            {isShowcashout(value?.marketId) && receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId === value?.marketId).length > 0 ? (
                                                <div className='cashout-btn'> <button className='btn' onClick={(e)=>handleCashOutMO(value?.marketId,e)}>Cashout</button></div>) : <></>}

                                            <div className='odds-heading'>
                                                <div className='heading-text box blue'>Back</div>
                                                <div className='heading-text box pink'>Lay</div>
                                            </div>
                                        </div>
                                        <div className='match-data'>
                                            <div className='match-list' id={value.marketId}>
                                            {value?.runners?.length > 0 ? (
                                                value.runners.map((runner, index) => (
                                                    <div className='data-with-betslip' key={index} id={runner.runnerId}>
                                                        <div className='match-info-row'>
                                                            <div className='match-name'>{runner.runnerName}</div> 
                                                            {setProfitloss(value?.marketId,runner.runnerId)} 
                                                            <div className='match-odds'>
                                                                <div className='box'>
                                                                    <BackPricesBox
                                                                        runner={runner}
                                                                        config={config}
                                                                        value={value}
                                                                        checkMaxOdds={checkMaxOdds}
                                                                        validationBM={validationBM}
                                                                        getLock={getLock}
                                                                        handleOnBackClick={handleOnBackClick}
                                                                        checkSuspendedMatchOdds={checkSuspendedMatchOdds(runner.status,value)}
                                                                        getBoxValue={(lay) => (
                                                                            <>
                                                                            {lay.price}
                                                                            {lay.size && <small>{ formatNumber(lay.size)}</small>}
                                                                            </>
                                                                        )}
                                                                        /> 
                                                                </div>
                                                                <div className='box'>
                                                                    <LayPricesBox
                                                                        runner={runner}
                                                                        config={config}
                                                                        value={value}
                                                                        checkMaxOdds={checkMaxOdds}
                                                                        validationBM={validationBM}
                                                                        getLock={getLock}
                                                                        handleOnBackClick={handleOnBackClick}
                                                                        checkSuspendedMatchOdds={checkSuspendedMatchOdds(runner.status,value)}
                                                                        getBoxValue={(lay) => (
                                                                            <>
                                                                            {lay.price}
                                                                            {lay.size && <small>{formatNumber(lay.size)}</small>}
                                                                            </>
                                                                        )}
                                                                        />
                                                                </div>
                                                                {getSuspendedMatchOdds(runner.status,value)}
                                                            </div>     
                                                        </div>
                                                        {currentBetSlip == `${value.marketId}_${runner.runnerId}` ? 
                                                            getbetSlip(config.isNotfancy,value.marketId,runner.runnerId,checkSuspendedMatchOdds(runner.status,value))
                                                        :<></>}
                                                        

                                                        {/* {getbetSlip(runner,config.isNotfancy)} */}
                                                    </div>
                                                ))
                                            ):(<p>Loading Match Odds market data...</p>)}
                                            </div>
                                        </div>

                                        </AccordionItem>
                                            </Accordion>
                                        </div>
                                    </div>
                                );
                            })
                        }

                        {apiResponse && bookmakerMarket &&
                            Object.entries(bookmakerMarket).map(([key, value]) => {
                                return (
                                <div id={key} className='sport-all-data inner-match-list'>
                                <div className='match-wrapper'>
                                    <Accordion transition transitionTimeout={350}>
                                        <AccordionItem initialEntered header={<div className={`heading ${sessionStorage.getItem('userId') ? 'w-star':''}`}>
                                                                <div className='heading-text sport-name'>
                                                                   {value?.marketName !== undefined ? `${value?.marketName}`: 'Bookmaker'}  
                                                                   <span className='rulespopup-btn' onClick={(e)=>grulesHandle(e)}><i className="fa-solid fa-circle-info"></i></span>
                                                                   {isCommission(value.marketId) ? <span className='blink'>*</span> :''}
                                                                </div>
                                                                <div className='heading-text sport-name'>
                                                                    {getMyMinMax(value.marketId)}
                                                                </div>
                                                                {sessionStorage.getItem('userId') ? (
                                                                    isMarketIdPresent(multimarketArray,value.marketId) ? (<svg className='star-icon' onClick={(e)=>mutliMarketAddRemove(value.marketId,eventId,e)} xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                                            <path d="M12.3834 1.13606C13.0434 -0.201277 14.9514 -0.201277 15.6114 1.13606L18.7554 7.50672L25.7861 8.52806C27.2621 8.74139 27.8514 10.5574 26.7834 11.5987L25.5754 12.7761C24.0802 11.9352 22.3691 11.557 20.6588 11.6894C18.9485 11.8217 17.3159 12.4586 15.9678 13.5194C14.6198 14.5802 13.6168 16.0172 13.086 17.6484C12.5552 19.2797 12.5204 21.0317 12.9861 22.6827L7.71006 25.4561C6.39006 26.1494 4.84606 25.0294 5.09672 23.5587L6.29806 16.5574L1.21139 11.5974C0.143391 10.5574 0.732724 8.74272 2.20872 8.52806L9.23939 7.50672L12.3834 1.13606ZM28.6634 20.3334C28.6634 18.3885 27.8908 16.5232 26.5155 15.1479C25.1402 13.7727 23.275 13.0001 21.3301 13.0001C19.3851 13.0001 17.5199 13.7727 16.1446 15.1479C14.7693 16.5232 13.9967 18.3885 13.9967 20.3334C13.9967 22.2783 14.7693 24.1436 16.1446 25.5188C17.5199 26.8941 19.3851 27.6667 21.3301 27.6667C23.275 27.6667 25.1402 26.8941 26.5155 25.5188C27.8908 24.1436 28.6634 22.2783 28.6634 20.3334ZM21.9967 21.0001L21.9994 24.3374C21.9994 24.5142 21.9292 24.6838 21.8041 24.8088C21.6791 24.9338 21.5095 25.0041 21.3327 25.0041C21.1559 25.0041 20.9863 24.9338 20.8613 24.8088C20.7363 24.6838 20.6661 24.5142 20.6661 24.3374V21.0001H17.3261C17.1492 21.0001 16.9797 20.9298 16.8547 20.8048C16.7296 20.6798 16.6594 20.5102 16.6594 20.3334C16.6594 20.1566 16.7296 19.987 16.8547 19.862C16.9797 19.737 17.1492 19.6667 17.3261 19.6667H20.6661L20.6647 16.3321C20.6647 16.1552 20.735 15.9857 20.86 15.8607C20.985 15.7356 21.1546 15.6654 21.3314 15.6654C21.5082 15.6654 21.6778 15.7356 21.8028 15.8607C21.9278 15.9857 21.9981 16.1552 21.9981 16.3321V19.6654H25.3274C25.5042 19.6654 25.6738 19.7356 25.7988 19.8607C25.9238 19.9857 25.9941 20.1552 25.9941 20.3321C25.9941 20.5089 25.9238 20.6784 25.7988 20.8035C25.6738 20.9285 25.5042 20.9987 25.3274 20.9987H21.9994L21.9967 21.0001Z" fill="#182EA6"></path>
                                                                        </svg>
                                                                    ) :(<svg onClick={(e)=> mutliMarketAddRemove(value.marketId,eventId,e)} className='star-icon' xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                                            <path d="M12.3839 1.136C13.0439 -0.201338 14.9519 -0.201338 15.6119 1.136L18.7559 7.50666L25.7865 8.528C27.2625 8.74133 27.8519 10.5573 26.7839 11.5987L25.5772 12.7747C24.9405 12.4162 24.2609 12.1402 23.5545 11.9533L25.0972 10.4493L18.3639 9.47066C18.0751 9.42853 17.8009 9.31683 17.5649 9.14518C17.3289 8.97353 17.1382 8.74708 17.0092 8.48533L13.9972 2.38666L10.9865 8.48533C10.8575 8.74708 10.6668 8.97353 10.4308 9.14518C10.1948 9.31683 9.92064 9.42853 9.63188 9.47066L2.89855 10.4493L7.77055 15.1987C8.19455 15.612 8.38788 16.208 8.28788 16.792L7.13855 23.4973L12.6705 20.5893C12.6905 21.312 12.8012 22.012 12.9879 22.6813L7.71055 25.456C6.39055 26.1493 4.84655 25.0293 5.09721 23.5587L6.29855 16.5573L1.21188 11.5973C0.143879 10.5573 0.733212 8.74266 2.20921 8.528L9.23988 7.50666L12.3839 1.136ZM28.6665 20.3333C28.6665 18.3884 27.8939 16.5231 26.5187 15.1479C25.1434 13.7726 23.2781 13 21.3332 13C19.3883 13 17.523 13.7726 16.1478 15.1479C14.7725 16.5231 13.9999 18.3884 13.9999 20.3333C13.9999 22.2783 14.7725 24.1435 16.1478 25.5188C17.523 26.894 19.3883 27.6667 21.3332 27.6667C23.2781 27.6667 25.1434 26.894 26.5187 25.5188C27.8939 24.1435 28.6665 22.2783 28.6665 20.3333ZM21.9999 21L22.0012 24.3373C22.0012 24.5141 21.931 24.6837 21.8059 24.8087C21.6809 24.9338 21.5114 25.004 21.3345 25.004C21.1577 25.004 20.9882 24.9338 20.8631 24.8087C20.7381 24.6837 20.6679 24.5141 20.6679 24.3373V21H17.3279C17.1511 21 16.9815 20.9298 16.8565 20.8047C16.7314 20.6797 16.6612 20.5101 16.6612 20.3333C16.6612 20.1565 16.7314 19.9869 16.8565 19.8619C16.9815 19.7369 17.1511 19.6667 17.3279 19.6667H20.6665V16.332C20.6665 16.1552 20.7368 15.9856 20.8618 15.8606C20.9868 15.7356 21.1564 15.6653 21.3332 15.6653C21.51 15.6653 21.6796 15.7356 21.8046 15.8606C21.9296 15.9856 21.9999 16.1552 21.9999 16.332V19.6653H25.3292C25.506 19.6653 25.6756 19.7356 25.8006 19.8606C25.9256 19.9856 25.9959 20.1552 25.9959 20.332C25.9959 20.5088 25.9256 20.6784 25.8006 20.8034C25.6756 20.9284 25.506 20.9987 25.3292 20.9987L21.9999 21Z" fill="#182EA6"/>
                                                                        </svg>
                                                                    )
                                                                ) :'' }
                                                            </div>}>
                                                            
                                        <div className='heading match-heading'>
                                            <div className='heading-text sport-name'>
                                                Market
                                            </div>

                                            {isShowcashout(value?.marketId) && receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId === value?.marketId).length > 0 ? (
                                                <div className='cashout-btn'> <button className='btn' onClick={(e)=>handleCashOutMO(value?.marketId,e)}>Cashout</button></div>) : <></>}

                                            <div className='odds-heading col2-odds-heading'>
                                                <div className='heading-text box blue'>Back</div>
                                                <div className='heading-text box pink'>Lay</div>
                                            </div>
                                        </div>
                                        <div className='match-data'>
                                            <div className='match-list' id={value.marketId}>
                                            {value?.runners?.length > 0 ? (
                                                value.runners.map((runner, index) => (
                                                    <div className='data-with-betslip' key={index} id={runner.runnerId}>
                                                        <div className='match-info-row'>
                                                            <div className='match-name'>{runner.runnerName}</div> 
                                                            {setProfitloss(value?.marketId,runner.runnerId)} 
                                                            <div className='match-odds'>
                                                                <div className='box'>
                                                                <BMBackPriceBox runner={runner}
                                                                    config={config}
                                                                    value={value}
                                                                    checkMaxOdds={checkMaxOdds}
                                                                    validationBM={validationBM}
                                                                    getLock={getLock}
                                                                    handleOnBackClick={handleOnBackClick}
                                                                    checkSuspendedMatchOdds={checkSuspendedMatchOdds(runner.status,value)}
                                                                    getBMBoxValue={getBMBoxValue}/>
                                                                </div>
                                                                <div className='box'>
                                                                <BMLayPriesBox
                                                                    runner={runner}
                                                                    config={config}
                                                                    value={value}
                                                                    checkMaxOdds={checkMaxOdds}
                                                                    validationBM={validationBM}
                                                                    getLock={getLock}
                                                                    checkSuspendedMatchOdds={checkSuspendedMatchOdds(runner.status,value)}
                                                                    handleOnBackClick={handleOnBackClick}
                                                                    getBMBoxValue={getBMBoxValue} />
                                                                </div>
                                                                {getSuspendedMatchOdds(runner.status,value)}
                                                            </div>     
                                                        </div>
                                                        
                                                        {currentBetSlip == `${value.marketId}_${runner.runnerId}` ? 
                                                            getbetSlip(config.isNotfancy,value.marketId,runner.runnerId,checkSuspendedMatchOdds(runner.status,value))
                                                        :<></>}

                                                        
                                                    </div>
                                                ))
                                            ):(<p>Loading Bookmaker market data...</p>)}
                                            </div>
                                        </div>
                                                            </AccordionItem>
                                    </Accordion>
                                </div>
                                </div>)
                            })
                        }

                        {apiResponse && underOver && 
                            Object.entries(underOver).map(([key, value]) => {
                                return (
                                    <div id={key} className='sport-all-data inner-match-list'>
                                        <div className='match-wrapper'>
                                            <Accordion transition transitionTimeout={350}>
                                            <AccordionItem initialEntered header={
                            <div className={`heading ${sessionStorage.getItem('userId') ? 'w-star':''}`}>
                                            <div className='heading-text sport-name'>
                                            {value?.marketName} <span className='rulespopup-btn' onClick={(e)=>grulesHandle(e)}><i className="fa-solid fa-circle-info"></i></span>
                                            </div>
                                            <div className='heading-text sport-name'>
                                            {getMyMinMax(value.marketId)}
                                            </div>
                                            {sessionStorage.getItem('userId') ? (
                                                isMarketIdPresent(multimarketArray,value.marketId) ? (<svg className='star-icon' onClick={(e)=>mutliMarketAddRemove(value.marketId,eventId,e)} xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                        <path d="M12.3834 1.13606C13.0434 -0.201277 14.9514 -0.201277 15.6114 1.13606L18.7554 7.50672L25.7861 8.52806C27.2621 8.74139 27.8514 10.5574 26.7834 11.5987L25.5754 12.7761C24.0802 11.9352 22.3691 11.557 20.6588 11.6894C18.9485 11.8217 17.3159 12.4586 15.9678 13.5194C14.6198 14.5802 13.6168 16.0172 13.086 17.6484C12.5552 19.2797 12.5204 21.0317 12.9861 22.6827L7.71006 25.4561C6.39006 26.1494 4.84606 25.0294 5.09672 23.5587L6.29806 16.5574L1.21139 11.5974C0.143391 10.5574 0.732724 8.74272 2.20872 8.52806L9.23939 7.50672L12.3834 1.13606ZM28.6634 20.3334C28.6634 18.3885 27.8908 16.5232 26.5155 15.1479C25.1402 13.7727 23.275 13.0001 21.3301 13.0001C19.3851 13.0001 17.5199 13.7727 16.1446 15.1479C14.7693 16.5232 13.9967 18.3885 13.9967 20.3334C13.9967 22.2783 14.7693 24.1436 16.1446 25.5188C17.5199 26.8941 19.3851 27.6667 21.3301 27.6667C23.275 27.6667 25.1402 26.8941 26.5155 25.5188C27.8908 24.1436 28.6634 22.2783 28.6634 20.3334ZM21.9967 21.0001L21.9994 24.3374C21.9994 24.5142 21.9292 24.6838 21.8041 24.8088C21.6791 24.9338 21.5095 25.0041 21.3327 25.0041C21.1559 25.0041 20.9863 24.9338 20.8613 24.8088C20.7363 24.6838 20.6661 24.5142 20.6661 24.3374V21.0001H17.3261C17.1492 21.0001 16.9797 20.9298 16.8547 20.8048C16.7296 20.6798 16.6594 20.5102 16.6594 20.3334C16.6594 20.1566 16.7296 19.987 16.8547 19.862C16.9797 19.737 17.1492 19.6667 17.3261 19.6667H20.6661L20.6647 16.3321C20.6647 16.1552 20.735 15.9857 20.86 15.8607C20.985 15.7356 21.1546 15.6654 21.3314 15.6654C21.5082 15.6654 21.6778 15.7356 21.8028 15.8607C21.9278 15.9857 21.9981 16.1552 21.9981 16.3321V19.6654H25.3274C25.5042 19.6654 25.6738 19.7356 25.7988 19.8607C25.9238 19.9857 25.9941 20.1552 25.9941 20.3321C25.9941 20.5089 25.9238 20.6784 25.7988 20.8035C25.6738 20.9285 25.5042 20.9987 25.3274 20.9987H21.9994L21.9967 21.0001Z" fill="#182EA6"></path>
                                                    </svg>
                                                ) :(<svg onClick={(e)=> mutliMarketAddRemove(value.marketId,eventId,e)} className='star-icon' xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                        <path d="M12.3839 1.136C13.0439 -0.201338 14.9519 -0.201338 15.6119 1.136L18.7559 7.50666L25.7865 8.528C27.2625 8.74133 27.8519 10.5573 26.7839 11.5987L25.5772 12.7747C24.9405 12.4162 24.2609 12.1402 23.5545 11.9533L25.0972 10.4493L18.3639 9.47066C18.0751 9.42853 17.8009 9.31683 17.5649 9.14518C17.3289 8.97353 17.1382 8.74708 17.0092 8.48533L13.9972 2.38666L10.9865 8.48533C10.8575 8.74708 10.6668 8.97353 10.4308 9.14518C10.1948 9.31683 9.92064 9.42853 9.63188 9.47066L2.89855 10.4493L7.77055 15.1987C8.19455 15.612 8.38788 16.208 8.28788 16.792L7.13855 23.4973L12.6705 20.5893C12.6905 21.312 12.8012 22.012 12.9879 22.6813L7.71055 25.456C6.39055 26.1493 4.84655 25.0293 5.09721 23.5587L6.29855 16.5573L1.21188 11.5973C0.143879 10.5573 0.733212 8.74266 2.20921 8.528L9.23988 7.50666L12.3839 1.136ZM28.6665 20.3333C28.6665 18.3884 27.8939 16.5231 26.5187 15.1479C25.1434 13.7726 23.2781 13 21.3332 13C19.3883 13 17.523 13.7726 16.1478 15.1479C14.7725 16.5231 13.9999 18.3884 13.9999 20.3333C13.9999 22.2783 14.7725 24.1435 16.1478 25.5188C17.523 26.894 19.3883 27.6667 21.3332 27.6667C23.2781 27.6667 25.1434 26.894 26.5187 25.5188C27.8939 24.1435 28.6665 22.2783 28.6665 20.3333ZM21.9999 21L22.0012 24.3373C22.0012 24.5141 21.931 24.6837 21.8059 24.8087C21.6809 24.9338 21.5114 25.004 21.3345 25.004C21.1577 25.004 20.9882 24.9338 20.8631 24.8087C20.7381 24.6837 20.6679 24.5141 20.6679 24.3373V21H17.3279C17.1511 21 16.9815 20.9298 16.8565 20.8047C16.7314 20.6797 16.6612 20.5101 16.6612 20.3333C16.6612 20.1565 16.7314 19.9869 16.8565 19.8619C16.9815 19.7369 17.1511 19.6667 17.3279 19.6667H20.6665V16.332C20.6665 16.1552 20.7368 15.9856 20.8618 15.8606C20.9868 15.7356 21.1564 15.6653 21.3332 15.6653C21.51 15.6653 21.6796 15.7356 21.8046 15.8606C21.9296 15.9856 21.9999 16.1552 21.9999 16.332V19.6653H25.3292C25.506 19.6653 25.6756 19.7356 25.8006 19.8606C25.9256 19.9856 25.9959 20.1552 25.9959 20.332C25.9959 20.5088 25.9256 20.6784 25.8006 20.8034C25.6756 20.9284 25.506 20.9987 25.3292 20.9987L21.9999 21Z" fill="#182EA6"/>
                                                    </svg>
                                                )
                                            ) :'' }
                                        </div>}>

                                        <div className='heading match-heading'>
                                            <div className='heading-text sport-name'>
                                                Market
                                            </div>

                                            {isShowcashout(value?.marketId) && receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId === value?.marketId).length > 0 ? (
                                                <div className='cashout-btn'> <button className='btn' onClick={(e)=>handleCashOutMO(value?.marketId,e)}>Cashout</button></div>) : <></>}

                                            <div className='odds-heading'>
                                                <div className='heading-text box blue'>Back</div>
                                                <div className='heading-text box pink'>Lay</div>
                                            </div>
                                        </div>
                                        <div className='match-data'>
                                            <div className='match-list' id={value.marketId}>
                                            {value?.runners?.length > 0 ? (
                                                value.runners.map((runner, index) => (
                                                    <div className='data-with-betslip' key={index} id={runner.runnerId}>
                                                        <div className='match-info-row'>
                                                            <div className='match-name'>{runner.runnerName}</div> 
                                                            {setProfitloss(value?.marketId,runner.runnerId)} 
                                                            <div className='match-odds'>
                                                                <div className='box'>
                                                                    <BackPricesBox
                                                                        runner={runner}
                                                                        config={config}
                                                                        value={value}
                                                                        checkMaxOdds={checkMaxOdds}
                                                                        validationBM={validationBM}
                                                                        getLock={getLock}
                                                                        handleOnBackClick={handleOnBackClick}
                                                                        checkSuspendedMatchOdds={checkSuspendedMatchOdds(runner.status,value)}
                                                                        getBoxValue={(lay) => (
                                                                            <>
                                                                            {lay.price}
                                                                            {lay.size && <small>{ formatNumber(lay.size)}</small>}
                                                                            </>
                                                                        )}
                                                                        /> 
                                                                </div>
                                                                <div className='box'>
                                                                    <LayPricesBox
                                                                        runner={runner}
                                                                        config={config}
                                                                        value={value}
                                                                        checkMaxOdds={checkMaxOdds}
                                                                        validationBM={validationBM}
                                                                        getLock={getLock}
                                                                        handleOnBackClick={handleOnBackClick}
                                                                        checkSuspendedMatchOdds={checkSuspendedMatchOdds(runner.status,value)}
                                                                        getBoxValue={(lay) => (
                                                                            <>
                                                                            {lay.price}
                                                                            {lay.size && <small>{formatNumber(lay.size)}</small>}
                                                                            </>
                                                                        )}
                                                                        />
                                                                </div>
                                                                {getSuspendedMatchOdds(runner.status,value)}
                                                            </div>     
                                                        </div>
                                                        {currentBetSlip == `${value.marketId}_${runner.runnerId}` ? 
                                                            getbetSlip(config.isNotfancy,value.marketId,runner.runnerId,checkSuspendedMatchOdds(runner.status,value))
                                                        :<></>}
                                                        
                                                    </div>
                                                ))
                                            ):(<p>Loading Match Odds market data...</p>)}
                                            </div>
                                        </div>

                                        </AccordionItem>
                                            </Accordion>
                                        </div>
                                    </div>
                                );
                            })
                        }

                        {checkFancy(config.typeSession) ||
                        checkFancy(config.typeOnlyOver) ||
                        checkFancy(config.typeWPmarket) ||
                        checkFancy(config.typeOddEven) ||
                        checkFancy(config.typeWinningSeat) ||
                        checkFancy(config.typeBallbyBall) ? (
                            <div className='sport-all-data inner-match-list fancylist'>
                            <div className='match-wrapper'>
                                <Accordion transition transitionTimeout={350}>
                                    <AccordionItem initialEntered header={<div className='heading'>
                                                        <div className='heading-text sport-name'>
                                                            Fancy <span className='rulespopup-btn' onClick={(e) => {
                                                e.stopPropagation(); // Prevent accordion toggle
                                                grulesHandle(); // Call your function
                                              }}><i className="fa-solid fa-circle-info"></i></span>
                                                        </div>
                                                    </div>}>
                                        <div className='fancytabs'>
                                        <div className='fancytab-btns'>
                                            <button className={tab === 'all' ? 'active' : ''} onClick={() => setTab('all')}>All</button>
                                            {checkFancy(config.typeSession)?<button className={tab === config.typeSession ? 'active' : ''} onClick={() => setTab(config.typeSession)}>Session</button>:'' }
                                            {checkFancy(config.typeOnlyOver)?<button className={tab === config.typeOnlyOver ? 'active' : ''} onClick={() => setTab(config.typeOnlyOver)}>Only Over</button>:'' }
                                            {checkFancy(config.typeWPmarket)?<button className={tab === config.typeWPmarket ? 'active' : ''} onClick={() => setTab(config.typeWPmarket)}>W/P Market</button>:'' }
                                            {checkFancy(config.typeOddEven)?<button className={tab === config.typeOddEven ? 'active' : ''} onClick={() => setTab(config.typeOddEven)}>Odd/Even</button>:'' }
                                            {checkFancy(config.typeWinningSeat)?<button className={tab === config.typeWinningSeat ? 'active' : ''} onClick={() => setTab(config.typeWinningSeat)}>Winnig Seats</button>:'' }
                                            {checkFancy(config.typeBallbyBall) ?<button className={tab === config.typeBallbyBall ? 'active' : ''} onClick={() => setTab(config.typeBallbyBall)}>Ball By Ball</button>:'' }
                                        </div>
                                        <div className='fancytab-content'>
                                        
                                        {fancyType.map((type) => (
                                            fancyData?.filter((item) => item.category === type).length > 0 && (
                                                <div className={`fancytab ${tab === type ? 'active' : tab === 'all' ? 'active' :'hide'}`}>
                                            <Accordion transition transitionTimeout={350}>
                                                <AccordionItem initialEntered header={<div className='heading match-heading'>
                                                                <div className='heading-text sport-name'> {getTitleName(type)} </div>
                                                                <div className='odds-heading col2-odds-heading'>
                                                                    <div className='heading-text box pink'>No</div>
                                                                    <div className='heading-text box blue'>Yes</div>
                                                                </div>
                                                            </div>}>
                                                    <div className='match-data'>
                                                        <div className='match-list'>
                                                            {fancyData?.filter((item) => item.category === type).sort(type === "OVERS" ? customSort : undefined).map((value, index) => (
                                                                <>
                                                                <div className='data-with-betslip' key={index}>
                                                                    <div className='match-info-row'>
                                                                    <div className='match-name'>{value.marketName}{
                                                                receivedBetlistData && receivedBetlistData?.bets?.bets && receivedBetlistData?.bets?.bets.filter(item => item.marketId.toString() === value.marketId.toString()).length > 0 ? (
                                                                    <button className={`btn fancy-book-btn`} onClick={() => handleShow(value.marketId)}>Book</button>
                                                                ) : null
                                                            }</div>
                                                            <div className='market-limit'>{getMyMinMax(value.marketId)}</div>
                                                            <div className='match-odds'>
                                                                <div className="box">
                                                                    <FancyNoValueBox
                                                                        value={value}
                                                                        checkMaxOdds={checkMaxOdds}
                                                                        validation={validation}
                                                                        getLock={getLock}
                                                                        handleOnBackClick={handleOnBackClick} />
                                                                </div>
                                                                <div className="box">
                                                                <FancyYesValueBox
                                                                    value={value}
                                                                    checkMaxOdds={checkMaxOdds}
                                                                    validation={validation}
                                                                    getLock={getLock}
                                                                    handleOnBackClick={handleOnBackClick} />
                                                                </div>
                                                                {fancySuspend(value)}
                                                            </div>
                                                                </div>
                                                                {currentBetSlip === `${value.marketId}` ?
                                                                getbetSlip(config.fancy,value.marketId,value.marketId,isFancySuspend(value))
                                                                :<></>}
                                                                
                                                            </div>
                                                            </>
                                                        ))}
                                                        </div>
                                                    </div>            
                                                </AccordionItem>
                                            </Accordion> 
                                            </div>
                                                            ))
                                                        )}
                                        </div>
                                        </div>
                                    </AccordionItem>
                                </Accordion>

                            </div>
                        </div>
                        ):<></>}
                    </div>

                    </div>

                    {apiResponse ?
                    <div className='right-content sidebar'>
                        {apiResponse.matchData && apiResponse.matchData.status == 'IN_PLAY' && liveStreamfunction(width,tvUrl,eventId,scoreAPICall) ?
                        <div className='sidebar-box live-stream'>
                            <div className='title live-stream-title' onClick={liveStreamHandle}>Live Stream</div>
                            <div className={`livestream-iframe ${liveStreamSlide && liveStreamSlide ? 'open':'' }`}>
                            {  width > 767 && scoreAPICall ? tvUrl && eventId ? <StringToHtml htmlString={tvUrl}  /> : <iframe src={`https://tv-quq1tgjxfpeu.fstlive.video/?eventid=${eventId}`} ></iframe> :''}
                            </div>
                        </div> 
                        : ''
                        }
                        <div className='sidebar-box'>
                            <div className='title'>Open Bets ({receivedBetlistData?.bets?.bets?.length})</div>
                            {receivedBetlistData?.bets?.bets?.length > 0 ?
                                <div className='betlist'>
                                    {loggedIn || sessionStorage.getItem('token') ?
                                        <table className="betlist-table">
                                            <thead>
                                                <tr>
                                                    <th>Selection</th>
                                                    <th>Odds</th>
                                                    <th>Market</th>
                                                    <th>Stake</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {receivedBetlistData?.bets?.bets?.map((item, index) => (
                                                    <tr key={index} className={`${item?.bettype2 === 'BACK' ? 'back' : 'lay'}`}>
                                                        <td> {item?.selectionName}</td>
                                                        <td> {item?.oddValue}</td>
                                                        <td> {item?.marketName}</td>
                                                        <td> {item?.Stake}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table> : ''}
                                </div> : ''}
                        </div>
                    </div> : <div className='sidebar skeleton'></div>
                    }
                </div>
                :
                <div className={`${matchStatuss === 0 ? 'hide' : matchStatuss === 1 ? 'hide' : 'show'}`}> <MatchNotFound />  </div>}

            </Container>
            <FancyBookPopup isopen={fancyBookPopup} handleClose={handleClose} receivedBookFancy={receivedBookFancy} />
            <Popup popupClass={`alertMsgpopup ${betPopup ? 'open' : ''}`} content={<div className={`alert-msg ${betresultMsg?.status === 'Error' ? 'err' : ''}`}> <span className='msg'>{betresultMsg?.status === 'success' ? betresultMsg?.msg : betresultMsg?.message}</span><div className="alert-progress-bar"></div> </div>} />
            <ExchanngeinfoPopup isOpen={grulesPopup} handleClose={gruleshandleClose} />
        </>
  )
}
